import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { FONT, GRID } from '../../constants';
export function createBaseFontStyles() {
  return {
    fontFamily: FONT.family,
    textAlign: 'left',
    margin: 0
  };
}
export var StyledHeader = _styled("span", {
  target: "e1pko4z70",
  label: "StyledHeader"
})({
  fontFamily: FONT.family,
  textAlign: 'left',
  margin: 0
}, function (_a) {
  var fontWeight = _a.fontWeight,
      margin = _a.margin,
      as = _a.as;
  return __assign(__assign({}, FONT.sizes[as]), {
    fontWeight: fontWeight,
    marginBottom: GRID[margin]
  });
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJhc2VTdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0IwQiIsImZpbGUiOiJiYXNlU3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsidmFyIF9fYXNzaWduID0gKHRoaXMgJiYgdGhpcy5fX2Fzc2lnbikgfHwgZnVuY3Rpb24gKCkge1xuICAgIF9fYXNzaWduID0gT2JqZWN0LmFzc2lnbiB8fCBmdW5jdGlvbih0KSB7XG4gICAgICAgIGZvciAodmFyIHMsIGkgPSAxLCBuID0gYXJndW1lbnRzLmxlbmd0aDsgaSA8IG47IGkrKykge1xuICAgICAgICAgICAgcyA9IGFyZ3VtZW50c1tpXTtcbiAgICAgICAgICAgIGZvciAodmFyIHAgaW4gcykgaWYgKE9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHkuY2FsbChzLCBwKSlcbiAgICAgICAgICAgICAgICB0W3BdID0gc1twXTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gdDtcbiAgICB9O1xuICAgIHJldHVybiBfX2Fzc2lnbi5hcHBseSh0aGlzLCBhcmd1bWVudHMpO1xufTtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEZPTlQsIEdSSUQgfSBmcm9tICcuLi8uLi9jb25zdGFudHMnO1xuZXhwb3J0IGZ1bmN0aW9uIGNyZWF0ZUJhc2VGb250U3R5bGVzKCkge1xuICAgIHJldHVybiB7XG4gICAgICAgIGZvbnRGYW1pbHk6IEZPTlQuZmFtaWx5LFxuICAgICAgICB0ZXh0QWxpZ246ICdsZWZ0JyxcbiAgICAgICAgbWFyZ2luOiAwLFxuICAgIH07XG59XG5leHBvcnQgdmFyIFN0eWxlZEhlYWRlciA9IHN0eWxlZC5zcGFuKHtcbiAgICBmb250RmFtaWx5OiBGT05ULmZhbWlseSxcbiAgICB0ZXh0QWxpZ246ICdsZWZ0JyxcbiAgICBtYXJnaW46IDAsXG59LCBmdW5jdGlvbiAoX2EpIHtcbiAgICB2YXIgZm9udFdlaWdodCA9IF9hLmZvbnRXZWlnaHQsIG1hcmdpbiA9IF9hLm1hcmdpbiwgYXMgPSBfYS5hcztcbiAgICByZXR1cm4gKF9fYXNzaWduKF9fYXNzaWduKHt9LCBGT05ULnNpemVzW2FzXSksIHsgZm9udFdlaWdodDogZm9udFdlaWdodCwgbWFyZ2luQm90dG9tOiBHUklEW21hcmdpbl0gfSkpO1xufSk7XG4iXX0= */");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Type/baseStyles.js
// module id = 87
// module chunks = 0